module.exports = __webpack_public_path__ + "img/3987071_m.34474df9.jpg";